import React from 'react';

import { TextField } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import pt from 'date-fns/locale/pt-BR';

import {
    getCurrentMonthStart,
    getMonthYearDatePickerProps
} from '../utils/dateUtils';

const MonthDatePicker = ({
    disabled = false,
    label = 'Mês',
    maxDate = getCurrentMonthStart(),
    minDate = new Date(2025, 0, 1),
    onChange,
    value
}) => (
    <LocalizationProvider adapterLocale={pt} dateAdapter={AdapterDateFns}>
        <DatePicker
            label={label}
            value={value}
            disabled={disabled}
            {...getMonthYearDatePickerProps(onChange)}
            minDate={minDate}
            maxDate={maxDate}
            renderInput={(params) => <TextField {...params} fullWidth />}
        />
    </LocalizationProvider>
);

export default MonthDatePicker;
